import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { Edit, ReferenceField, SimpleForm, TextField } from "react-admin";
import { ListAreaContest } from "./ListAreaContest";
import { JsonInput } from "react-admin-json-view";
var AreaContestForm = function () {
    return (_jsxs(SimpleForm, { children: [_jsx(Typography, { variant: "h4", children: "Area" }), _jsx(Typography, { variant: "h5", children: "Election Event" }), _jsx(Typography, { variant: "h5", children: "ID" }), _jsx(TextField, { source: "id" }), _jsx(ReferenceField, { label: "Election Event", reference: "sequent_backend_election_event", source: "election_event_id", children: _jsx(TextField, { source: "name" }) }), _jsx(Typography, { variant: "h5", children: "Area" }), _jsx(ReferenceField, { label: "Area", reference: "sequent_backend_area", source: "area_id", children: _jsx(TextField, { source: "name" }) }), _jsx(Typography, { variant: "h5", children: "Contest" }), _jsx(ReferenceField, { label: "Contest", reference: "sequent_backend_contest", source: "contest_id", children: _jsx(TextField, { source: "name" }) }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] }));
};
export var EditAreaContest = function () {
    return (_jsx(ListAreaContest, { aside: _jsx(Edit, { sx: { flexGrow: 2, width: "50%", flexShrink: 0 }, children: _jsx(AreaContestForm, {}) }) }));
};
